const IMAGE_ENCODING_ERROR = "No se pudo procesar la imagen. Seleccioná otra imagen válida.";

export const JPEG_QUALITY_STEPS = [0.9, 0.8, 0.7, 0.6, 0.5] as const;

export const IMAGE_OPTIMIZATION_FAILED_MESSAGE =
  "La imagen no pudo optimizarse por debajo de 500 KB. Probá con una imagen de menor resolución.";

const encodeJpeg = (canvas: HTMLCanvasElement, quality: number): Promise<Blob> =>
  new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (!blob || blob.type !== "image/jpeg" || blob.size === 0) {
        reject(new Error(IMAGE_ENCODING_ERROR));
      } else {
        resolve(blob);
      }
    }, "image/jpeg", quality);
  });

export const compressCanvasToJpeg = async (canvas: HTMLCanvasElement, maxSizeKb: number): Promise<Blob> => {
  for (const quality of JPEG_QUALITY_STEPS) {
    const blob = await encodeJpeg(canvas, quality);
    if (blob.size <= maxSizeKb * 1024) return blob;
  }
  throw new Error(IMAGE_OPTIMIZATION_FAILED_MESSAGE);
};

export const compressImageToJpeg = async (file: Blob, maxSizeKb: number): Promise<Blob> => {
  const url = URL.createObjectURL(file);
  try {
    const image = await new Promise<HTMLImageElement>((resolve, reject) => {
      const candidate = new Image();
      candidate.onload = () => resolve(candidate);
      candidate.onerror = () => reject(new Error(IMAGE_ENCODING_ERROR));
      candidate.src = url;
    });
    if (!image.naturalWidth || !image.naturalHeight) throw new Error(IMAGE_ENCODING_ERROR);
    const canvas = document.createElement("canvas");
    canvas.width = image.naturalWidth;
    canvas.height = image.naturalHeight;
    const context = canvas.getContext("2d");
    if (!context) throw new Error(IMAGE_ENCODING_ERROR);
    context.fillStyle = "#ffffff";
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.drawImage(image, 0, 0);
    return await compressCanvasToJpeg(canvas, maxSizeKb);
  } finally {
    URL.revokeObjectURL(url);
  }
};
